<template>
    <div class="content">
        <form @submit="handleSubmit" v-if="customer.health_information">
            <div class="input-box">
              <label for="name">Nome do plano de saúde</label>
              <input
                id="name"
                name="name"
                type="text"
                v-model="customer.health_information.health_insurance"/>
              <small class="error" v-if="errors && errors != ''">{{errors}}</small>
            </div>
            <button @click.prevent="handleSubmit" class="button btn-primary" v-if="!loading">Salvar</button>
            <button class="button btn-primary" disabled v-if="loading">
              <loading/>
            </button>
        </form>
    </div>
</template>

<script>
  import {GET_CUSTOMER, POST_CUSTOMER} from '../../services/customer';
  import moment from 'moment';

  export default {
    props: ['values'],
    name: "edit-health-insurance",
    data() {
          return {
              loading: false,
              loadingScreen: false,
              customer: {},
              errors: '',
          }
        },
    methods: {
      outsideClick() {
          if(event.target === event.currentTarget)
              this.$emit('close');
      },
      async getCustomer() {
        this.$emit('setLoadingScreen', true);

        try {
          const data = await GET_CUSTOMER();
          this.customer = data.customer;
          if(this.customer.health_information == null){
              this.customer.health_information = {}
          }
        } catch(error) {
          console.log(error);
        } finally {
        this.$emit('setLoadingScreen', false);
        }
      },
      handleSubmit() {
        this.loading = true;
        let validate = this.verifyErrors();

        if(!validate){
          this.loading = false;
          return false;
        }

        let date = new Date(this.customer.birth_date);
        this.customer.birth_date = date.getFullYear() + '-' + (this.aditionalZero(date.getMonth() + 1)) + '-' + (this.aditionalZero(date.getDate()));
        this.customer.profile_picture = null;

        POST_CUSTOMER(this.customer).then(
          resp => {
            this.loading = false,
            this.$emit('updateCustomer', this.customer);
          }
        )
      },
      aditionalZero(number) {
          if (number <= 9) 
              return "0" + number;
          else
              return number; 
      },
      verifyErrors() {
        let validate = true;
        this.errors = '';

        if(this.customer.health_information.health_insurance == ''){
          this.errors = 'Preencha o nome do plano';
          validate = false;
        }

        return validate;
      },
    },
    mounted() {
      this.getCustomer();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CardHealthId/EditHealthInsurance.vue